export enum ROLE_ID {
	USER = 'USER',
	ADMINISTRATOR = 'ADMINISTRATOR',
	DYNAMIC_ADMIN = 'DYNAMIC_ADMIN',
}
